<script lang="ts">
  import '$features/workspace/styles/auth-guest.css';
  import { signInWithProvider, type SocialProvider } from '../stores/auth';

  let { disabled = false, onerror }: { disabled?: boolean; onerror?: (message: string) => void } = $props();

  let redirecting = $state<SocialProvider | null>(null);

  async function start(provider: SocialProvider) {
    redirecting = provider;
    try {
      await signInWithProvider(provider);
      // The browser navigates away; leave the button in its busy state.
    } catch (error) {
      redirecting = null;
      console.error('Social sign-in error:', error);
      onerror?.('We couldn’t start sign-in. Try again.');
    }
  }

  const isBusy = $derived(disabled || redirecting !== null);
</script>

<div class="ag-social">
  <p class="ag-divider">Or continue with</p>

  <div class="ag-social__buttons">
    <button
      type="button"
      class="stat-button stat-button--secondary ag-social__button"
      disabled={isBusy}
      aria-busy={redirecting === 'Google' ? 'true' : undefined}
      aria-label="Continue with Google"
      title="Continue with Google"
      onclick={() => start('Google')}
    >
      <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="#4285F4"
          d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47a5.53 5.53 0 0 1-2.4 3.63v3h3.86c2.26-2.09 3.56-5.17 3.56-8.87z"
        />
        <path
          fill="#34A853"
          d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09A11.99 11.99 0 0 0 12 24z"
        />
        <path
          fill="#FBBC05"
          d="M5.27 14.29A7.2 7.2 0 0 1 4.89 12c0-.79.14-1.56.38-2.29V6.62H1.29a11.99 11.99 0 0 0 0 10.76l3.98-3.09z"
        />
        <path
          fill="#EA4335"
          d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0A11.99 11.99 0 0 0 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z"
        />
      </svg>
    </button>

    <button
      type="button"
      class="stat-button stat-button--secondary ag-social__button"
      disabled={isBusy}
      aria-busy={redirecting === 'Apple' ? 'true' : undefined}
      aria-label="Continue with Apple"
      title="Continue with Apple"
      onclick={() => start('Apple')}
    >
      <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path
          d="M16.36 12.79c.03 3.26 2.86 4.35 2.89 4.36-.02.08-.45 1.55-1.49 3.07-.9 1.31-1.83 2.62-3.3 2.65-1.44.03-1.91-.86-3.56-.86s-2.17.83-3.53.89c-1.42.05-2.5-1.42-3.4-2.73C2.1 17.5.71 12.62 2.6 9.34a5.27 5.27 0 0 1 4.47-2.71c1.39-.03 2.71.94 3.56.94.85 0 2.45-1.16 4.13-.99.7.03 2.68.28 3.95 2.14-.1.06-2.36 1.38-2.35 4.07zM13.65 4.8c.75-.91 1.26-2.18 1.12-3.44-1.08.04-2.39.72-3.17 1.63-.7.81-1.31 2.1-1.14 3.34 1.2.09 2.44-.61 3.19-1.53z"
        />
      </svg>
    </button>

    <button
      type="button"
      class="stat-button stat-button--secondary ag-social__button"
      disabled={isBusy}
      aria-busy={redirecting === 'Microsoft' ? 'true' : undefined}
      aria-label="Continue with Microsoft"
      title="Continue with Microsoft"
      onclick={() => start('Microsoft')}
    >
      <svg width="22" height="22" viewBox="0 0 23 23" aria-hidden="true">
        <rect x="1" y="1" width="10" height="10" fill="#F25022" />
        <rect x="12" y="1" width="10" height="10" fill="#7FBA00" />
        <rect x="1" y="12" width="10" height="10" fill="#00A4EF" />
        <rect x="12" y="12" width="10" height="10" fill="#FFB900" />
      </svg>
    </button>
  </div>
</div>
